
// ********* Import CSS ***************** //

import "./faqs.css";

// ********* Import Images ***************** //

//*** ASATTC Spinner Image ***//
import "../assets/asattc-round-favicon/asattc-round-favicon.png";

// ** LOGO ** //


// ** IMAGES ** //


// ********* Add Top Nav & Footer *************** //

import '../nav-header-footer/nav-header-footer.js';
import '../nav-header-footer/nav-header-footer.css';

// **************************** Spinner ****************************** //

$(window).on('load', function(){
  document.getElementById("spinner").style.display = "block";
  setTimeout(removeSpinner, 1000);
});

function removeSpinner(){
  $( "#spinner" ).fadeOut(100, function() {
    $( "#spinner" ).remove();
  });
}